import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

export const ContextProvider = ({ children }) => {

    const [indexTab, setIndexTab] = useState('Electro');

    return(
        <StateContext.Provider
            value={{
                indexTab, 
                setIndexTab,
            }}
        >
            {children}
        </StateContext.Provider>
    )
}

export const useStateContext = () => useContext(StateContext);